import { reducer as footerReducer } from "./reducers";
import { FeatureConfiguration } from "../index";

export default function (config: FeatureConfiguration) {
    config.reducers.footer = footerReducer;
}
